export default [
  {
    path: "/home",
    name: "首页展示",
    iconClass: "el-icon-s-home",
    component: () => import("@/components/HomeAdmin"),
    meta: { menuShow: false },
  },
  {
    path: "/tenantsInfos",
    name: "租户信息",
    iconClass: "el-icon-user",
    component: () => import("@/components/tenant/TenantInfos.vue"),
    meta: { menuShow: false },
  },
  {
    path: "/tenantProfiles",
    name: "租户配置",
    iconClass: "el-icon-suitcase",
    component: () => import("@/components/tenant/TenantProfiles.vue"),
    meta: { menuShow: false },
  },
  {
    path: "/settings",
    name: "系统设置",
    // redirect: "/settings/general",
    iconClass: "el-icon-setting",
    meta: { menuShow: true },
    component: () => import("@/components/Settings.vue"),
    children: [
      {
        path: "/settings/general",
        name: "基本设置",
        component: () => import("@/components/settings/GeneralSetting.vue"),
      },
      {
        path: "/settings/queues",
        name: "队列",
        component: () => import("@/components/settings/Queues.vue"),
      },
    ],
  },
];
